<template>
  <v-dialog
    v-model="dialog"
    max-width="320"
  >
    <v-card>
      <v-card-title class="headline">Thông báo</v-card-title>

      <v-card-text class="pt-0">
        {{ description }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat="flat"
          @click="confirm"
        >
          Đồng ý
        </v-btn>

        <v-btn
          color="grey darken-1"
          flat="flat"
          @click="dialog = false"
        >
          Hủy
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: 'Bạn có muốn xóa?'
    }
  },

  data: () => ({
    dialog: false
  }),

  methods: {
    open () {
      this.dialog = true;
    },

    close () {
      this.dialog = false;
    },

    confirm () {
      this.$emit('confirm');
      this.close();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/DialogConfirm.vue